export const ExtensionsNames = {
  SPOILER_WRAPPER: 'spoilerWrapper',
  SPOILER_HEADER: 'spoilerHeader',
  SPOILER_PANEL: 'spoilerPanel',
  SUPPORTING_DOCUMENTS: 'supportingDocuments',
  RESIZABLE_IMAGE: 'resizableImage',
};

export function digForParent(desiredDepth, { tr, commands, state }) {
  const { $anchor } = tr.curSelection;
  const nodeStartPos = $anchor.pos - $anchor.parentOffset;
  const currentNodeContext = state.doc.resolve(nodeStartPos);

  let curDepth = currentNodeContext.depth;

  if (curDepth === desiredDepth) {
    commands.selectParentNode();
    const curNode = currentNodeContext.parent;
    return curNode;
  }

  let prevNodePos = nodeStartPos - 1;
  let newNodeContext;

  commands.selectParentNode();

  while ((curDepth--) > desiredDepth) {
    commands.selectParentNode();
    commands.selectParentNode();
    newNodeContext = state.doc.resolve(prevNodePos);
    prevNodePos = prevNodePos - newNodeContext.parentOffset - 1;
  }

  const curNode = newNodeContext.parent;
  return curNode;
}

export function getSelectedNodeEndPos(tr) {
  const currentSelectionStartPos = tr.curSelection.from;
  const { node } = tr.curSelection;
  const nodeContentLength = node.firstChild.firstChild.content.size;
  const newCursorPos = currentSelectionStartPos + nodeContentLength + 1;

  return newCursorPos;
}

export function insertEmptyParagraphIfAtLastDocumentNode(state, dispatch) {
  const { selection } = state;
  const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos;

  const nodeContext = state.doc.resolve(position);
  const isLastNode = nodeContext.parent === state.tr.doc.lastChild;
  if (isLastNode) {
    const emptyParagraphNode = state.schema.nodes.paragraph.create();
    const transaction = state.tr.insert(position, emptyParagraphNode);
    dispatch(transaction);
  }
}
